import { StyleSheet } from '@react-pdf/renderer';
import COLORS from '../../../resources/style/Themes';

export const reportStyles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 40,
    position: 'relative',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  section: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  logo: {
    width: 150,
    height: 'auto',
    padding: 10,
    marginLeft: 10,
    marginTop: 10,
    backgroundColor: COLORS.SAFEGUARD_BLUE,
  },
  generatedBySection: {
    position: 'absolute',
    bottom: 10,
    right: 10,
    textAlign: 'right',
  },
  header: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  subsectionHeader: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  text: {
    fontSize: 10,
  },
  boldText: {
    fontSize: 10,
    fontWeight: 'bold',
  },
  emergencyMessageText: {
    fontSize: 10,
    marginBottom: 2,
  },
  footerText: {
    fontSize: 8,
  },
  image: {
    width: 300,
    height: 150,
    marginVertical: 10,
    paddingLeft: 10,
  },
  messagesSection: {
    paddingRight: 10,
    paddingLeft: 10,
  },
});
